if (!customElements.get('sibling-selects')) {
  customElements.define(
    'sibling-selects',
    class SiblingSelects extends HTMLElement {
      constructor() {
        super();
      }
    }
  );
}
